import { DataService } from "@/services/data";
import { RouteObject } from "react-router-dom";
import { PaginatedResponse } from "@/types/common";
import { ProductThemeType } from "@/types/content/product_theme";
import { TabContentResponse } from "@/types/dynamic-detail";
import { getApprenticeshipDefaultProduct } from "@/utils/apprenticeship";

const AlternanceRoute: RouteObject = {
    path: "alternance",
    children: [
        {
            index: true,
            async lazy() {
                let { AlternancePage } = await import("@/pages/content/alternance/index");
                return { Component: AlternancePage };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);
                url.searchParams.set("domain", "alternance");
                url.searchParams.set("page_size", url.searchParams.get("page_size") || "8");
                url.searchParams.set("is_active", "1");

                const product_themes = (await DataService.client
                    .url(`/content/product_themes/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json()) as PaginatedResponse<ProductThemeType>;

                return {
                    product_themes
                };
            }
        },
        {
            id: "alternance-detail",
            path: ":id",
            async lazy() {
                let { AlternanceDetailPage } = await import("@/pages/content/alternance/detail");
                return { Component: AlternanceDetailPage };
            },
            loader: async ({ params }) => {
                const id = params.id;
                const product_theme = (await DataService.client.url(`/content/product_themes/${id}/`).get().json()) as ProductThemeType;
                const product = getApprenticeshipDefaultProduct(product_theme);
                const opco_funding_matrices = product?.id
                    ? ((await DataService.client
                          .url(`/crm/objects/products/${product.id}/tab-content/opco_funding_matrices/`)
                          .get()
                          .json()) as TabContentResponse)
                    : null;
                return { product_theme, opco_funding_matrices };
            }
        }
    ]
};
export default AlternanceRoute;
